<template>
  <div class="donate_content_box">
    <swiper class="donate_content_swiper" :options="swiperOption">
      <!-- 나눔 배움 슬라이드 -->
      <swiper-slide class="donate_content_swiper_slide" v-for="board in boardData" :key="`donate${board.wr_id}`"

      >

        <div class="donate_content_swiper_slide_blur"  @click="goDetail(board.wr_id)"></div>
        <img class="donate_content_swiper_slide_img" :src="returnImage(board)">
        <div class="donate_content_swiper_slide_textBox" @click="goDetail(board.wr_id)" >
          <div class="donate_content_swiper_slide_textBox_title">{{ board.wr_subject }}</div>
          <div class="donate_content_swiper_slide_textBox_text" v-html="decodeHtml(board.wr_content)"></div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BoardListHomeDonateLayout",
  mixins: [imageOption],
  components: {
    Swiper,
    SwiperSlide
  },
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      return `${board.NoticeFile.MobileFile[0].org_url}?${this.setImageOptions(650, 318, 'jpg')}`;
    },
    decodeHtml(html = '') {
      let img_tag = /<IMG(.*?)>/gi;
      let video_tag = /<iframe(.*?)>(.*?)<\/iframe>/gi;
      html = html.replace(img_tag, "");
      html = html.replace(video_tag, "");

      return util.htmlDecode(html);
    },
    goDetail(idx) {
      this.$router.push(`/donate/${idx}`)
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>